import React, {
  FunctionComponent,
  ReactNode,
  ReactElement,
  // useContext,
  // useState,
  // useEffect,
} from "react";
// import { AppBar, Tab, Tabs } from "@material-ui/core/";
import "./index.scss";
// import { ContentPageItemCollection } from "../../services/entities/content";
// import { ContentPageContext } from "../content/context";

// function a11yProps(index: any) {
//   return {
//     id: `simple-tab-${index}`,
//     "aria-controls": `simple-tabpanel-${index}`,
//   };
// }

type TabbedNavigationProps = {
  tabs?: object;
  children?: ReactNode | ReactNode[];
  props?: object;
};

export const TabbedNavigation: FunctionComponent<TabbedNavigationProps> = ({
  tabs,
  children,
}) => {
  // const [value, setValue] = useState(0);
  // const [dynamicTabs, setDynamicTabs] = useState<Array<string>>([]);
  // const [navigateTo, setNavigateTo] = useState(false);

  // const page = useContext(ContentPageContext);

  // const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
  //   setValue(newValue);
  //   setNavigateTo(true);
  // };

  // useEffect(() => {
  //   let data = tabs ? tabs : page;
  //   console.log("data -- - -", data);
  //   findVal(data, "tabTitle");
  // }, [page]);

  // function findVal(object: any, key: any) {
  //   Object.keys(object).map((components, i) => {
  //     if (components === "items") {
  //       Object.keys(object[components]).map((componentObj, i) => {
  //         if (
  //           components === "items" &&
  //           object[components][componentObj].hasOwnProperty("tabTitle")
  //         ) {
  //           const value = object[components][componentObj].tabTitle;
  //           return setDynamicTabs((dynamicTabs) => [...dynamicTabs, value]);
  //         }
  //         return false;
  //       });
  //     }
  //     return false;
  //   });
  // }

  const updateWithprops = React.Children.map(children, (child, i) => {
    return React.cloneElement(child as ReactElement | any, {
      // value,
      tabs,
      i,
      // navigateTo,
    });
  });
  return (
    <>
      <div className={`section--tabbed-navigation`}>
        {/* {dynamicTabs && dynamicTabs.length > 0 && (
          <AppBar position="relative" className="tabbed-navigation-inner">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="in page navigation"
              className="inner"
              variant="scrollable"
              scrollButtons="auto"
            >
              {dynamicTabs.map((tab: String, i) => {
                return (
                  <Tab
                    key={`tab-${i}`}
                    label={tab}
                    className="tabname"
                    {...a11yProps(i)}
                  />
                );
              })}
            </Tabs>
          </AppBar>
        )} */}
        {updateWithprops}
      </div>
    </>
  );
};

export default TabbedNavigation;
